import React from 'react';
import ContentLayout from 'components/ContentLayout/SmartLayout';
import ReturnItoReturnD from 'components/Sales/Smart/MoveMerge/MoveWarehouse/ReturnItoReturnD';
import { getWarehouseCodeFromCache } from 'utils';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';

export default function Page(): JSX.Element {
  return (
    <ContentLayout 
    titleKey="titles.returnItoReturn" value={getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))}
    // title={`From Return-Inspection to Return-Damage(W#: ${getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))})`}
    >
      <ReturnItoReturnD />
    </ContentLayout>
  );
}




